import React, { useSyncExternalStore } from 'react';
import { processingRealtimeStore } from '../services/processingRealtimeStore';
import './ProcessingConnectionNotice.css';

const getConnection = () => processingRealtimeStore.getConnectionState();

export default function ProcessingConnectionNotice() {
  const state = useSyncExternalStore(processingRealtimeStore.subscribeConnection, getConnection);
  if (state !== 'unavailable' && state !== 'reconnecting') return null;
  return <div className="processing-connection-notice" role="status">
    <span>{state === 'unavailable' ? 'Live updates are unavailable. Your work can continue.' : 'Reconnecting live updates…'}</span>
    <button type="button" onClick={() => processingRealtimeStore.refresh()}>Retry updates</button>
  </div>;
}
